export default __webpack_public_path__ + "static/countries-bg-image-facbc84fe5d15edda26ab0a0d74c52ac.jpg";